import { useCallback } from 'react';
import type { To } from 'react-router';
import { useNavigate } from 'react-router';

import { navigateBackOrFallback } from '#src/lib/routing.tsx';

export const useSafePreviousNavigate = (defaultPreviousLocation: To) => {
  const navigate = useNavigate();

  return useCallback(
    () => navigateBackOrFallback(navigate, defaultPreviousLocation),
    [navigate, defaultPreviousLocation]
  );
};
